module.exports = __webpack_public_path__ + "static/media/teresopolis-rj.83595e8b.jpg";